import React, { useRef } from 'react';
import './index.module.less';
import jsQR from "jsqr";
import Toast from '@widgets/Toast';
import { fileImage2DataURL, getImageOrientation } from './util';
import { getFitSize } from '@helpers/utils';
import { cropImageUtil } from './util/crop-image-util';
import { throttle } from 'lodash';
import FridayService from '@services/friday';

interface IImageScanProps {
  onScan?: (data: string) => void;
}

const ImageScan = (props: IImageScanProps) => {
  const { onScan } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  const init = () => {
    inputRef.current = document.createElement('input');
    inputRef.current.type = 'file';
    inputRef.current.accept = 'image/*';
    inputRef.current.multiple = false;
    inputRef.current.onchange = throttle(handleInputOnChange, 800);
  }

  const handleClickButton = throttle((e) => {
    e && e.stopPropagation()
    FridayService.addEvent('bind_device_scan_album_click');
    if (!inputRef.current) {
      init();
    }
    if (inputRef.current) {
      // 清空图片选择框的内容，防止某些安卓机子，重复选择相同照片时，不触发onChange事件
      inputRef.current.value = '';
      inputRef.current.click();
    } 
  }, 500)

  const handleInputOnChange = async () => {
    const file = inputRef.current && inputRef.current.files && inputRef.current.files[0];
    const fileType = file && file.type;
    if (!file || (fileType && !~fileType.indexOf('image'))) {
      Toast.show({
        type: 'strip',
        title: '请选择图片文件',
        timer: 2000
      });
      return;
    }

    try {
      const imgDataURL = await fileImage2DataURL(file);
      const orientation = await getImageOrientation(file);
      const imageSize = await getImageSize(imgDataURL, orientation);

      const { width, height } = getFitSize(imageSize.width, imageSize.height, 600, 600, 'contain');

      const canvas = await cropImageUtil.crop({src: imgDataURL, sWidth: imageSize.width, sHeight: imageSize.height, width: width, height: height, orientation});
      if (canvas) {
        // const dataURL = canvas.toDataURL('image/jpeg', 1);
        scanCode(canvas);
      }
    } catch (e) {
      console.error('error:', e);
      Toast.show({
        type: 'strip',
        title: '当前图片有误，请选择其它图片',
        timer: 2000
      });
    }
  }

  const getImageSize = (src: string, orientation?: number): any => {
    return new Promise((resolve) => {
      const image = new Image();
      image.setAttribute('crossOrigin', 'anonymous');
      image.src = src;
      image.onload = () => {
        const size = {width: image.width, height: image.height};
        if (orientation === 6 || orientation === 8) {
          const temp = size.width;
          size.width = size.height;
          size.height = temp;
        }
        resolve(size);
      };
    });
  }
  
  const scanCode = (canvas: HTMLCanvasElement) => {
    // getImageData() 复制画布上制定矩形的像素数据
    const imageData = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);
    let code;
    try {
      // 识别二维码
      code = jsQR(imageData.data, imageData.width, imageData.height);
    } catch (e) {
      console.error(e);
    }
    if (code && code.data) {
      onScan && onScan(code.data);
    } else {
      Toast.show({
        type: 'strip',
        title: '无法识别二维码，请选择清晰的二维码图片',
        timer: 2000
      });
    }
  }

  return (
    <div styleName="button" onClick={handleClickButton}>相册</div>
  )
}

export default ImageScan;
